var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.323 13.807 36.486 7.91c-.386-1.575-1.75-2.66-3.343-2.66H8.836c-1.575 0-2.958 1.103-3.325 2.66l-1.838 5.897c-.805 3.448 1.488 5.443 1.575 5.548V33.25a3.51 3.51 0 0 0 3.5 3.5h24.5a3.51 3.51 0 0 0 3.5-3.5V19.355c1.96-1.96 1.908-4.218 1.575-5.548ZM22.748 8.75h3.43l.945 6.16c.157 1.242-.683 2.59-2.24 2.59-1.172 0-2.135-1.032-2.135-2.293V8.75Zm-11.48 6.755c-.14 1.137-1.05 1.995-2.117 1.995-1.628 0-2.363-1.697-2.083-2.87l1.768-5.88h3.447l-1.015 6.755Zm7.98-.298c0 1.26-.963 2.293-2.258 2.293-1.312 0-2.274-1.225-2.134-2.59l.962-6.16h3.43v6.457ZM32.846 17.5c-1.068 0-1.995-.858-2.118-1.995L29.713 8.75l3.377-.018 1.838 5.898c.28 1.172-.438 2.87-2.082 2.87Z",
    fill: "#5575C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreFront);
export default __webpack_public_path__ + "static/media/storeFront.465d6b05911892dec4180d9ab1b40399.svg";
export { ForwardRef as ReactComponent };